<template>
  <div class="liquidacion-sueldos-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Liquidación">
          <b-table 
              small 
              class="datos-objeto" 
              :items="liquidacionSueldosDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Personal">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="liquidacionSueldosPersonalDatos" 
              :fields="personalFields">
            <template v-slot:cell(honorarios)="data">
              {{ data.item.honorarios | moneda }}
            </template>
            <template v-slot:cell(adicional)="data">
              {{ data.item.adicional | moneda }}
            </template>
            <template v-slot:cell(otrosConceptos)="data">
              {{ data.item.otrosConceptos | moneda }}
            </template>
            <template v-slot:cell(liquidacionFinal)="data">
              {{ data.item.liquidacionFinal | moneda }}
            </template>
            <template v-slot:cell(adelantos)="data">
              {{ data.item.adelantos | moneda }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
          </b-table>

          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes totales"
              :items="totalPersonal" 
              :fields="totalPersonalFields">
            <template v-slot:cell(honorarios)="data">
              {{ data.item.honorarios | moneda }}
            </template>
            <template v-slot:cell(adicional)="data">
              {{ data.item.adicional | moneda }}
            </template>
            <template v-slot:cell(otrosConceptos)="data">
              {{ data.item.otrosConceptos | moneda }}
            </template>
            <template v-slot:cell(liquidacionFinal)="data">
              {{ data.item.liquidacionFinal | moneda }}
            </template>
            <template v-slot:cell(adelantos)="data">
              {{ data.item.adelantos | moneda }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Pagos">
          <b-table 
              small 
              responsive="sm" 
              class="registro pagos"
              :items="liquidacionSueldosPagosDatos" 
              :fields="pagosFields"
              @row-clicked="consultarPago">
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="borrarPago(data.item)">
                  <i class="fa fa-remove"></i>Anular Pago</b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>

          <b-table 
              small 
              responsive="sm"
              class="registro pagos totales" 
              :items="totalPagos" 
              :fields="totalPagosFields">
            <template v-slot:cell(total)="data">
              {{ data.item.total | moneda }}
            </template>
          </b-table>

        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item 
              @click.stop="registrarPago">
            <i class="fa fa-usd"></i>Registrar Pago</b-dropdown-item>
          <b-dropdown-item 
              @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'liquidacionSueldos/getField',
  mutationType: 'liquidacionSueldos/updateField',
});

export default {
  name: 'LiquidacionSueldosData',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal,
    confirmModal
  ],
  data: () => {
    return {
      liquidacionSueldosId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      personalFields: [
        {
          key: 'numero',
          label: 'Nro.',
          // class: 'text-right'
        },
        {
          key: 'personal',
        },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right',
        },
        {
          key: 'adicional',
          class: 'text-right',
        },
        {
          key: 'otrosConceptos',
          class: 'text-right',
        },
        {
          key: 'liquidacionFinal',
          label: 'Liq. Final',
          class: 'text-right',
        },
        {
          key: 'adelantos',
          class: 'text-right',
        },
        {
          key: 'total',
          class: 'text-right',
        },
      ],
      totalPersonalFields: [
        {
          key: 'numero',
          label: ''
        },
        {
          key: 'totales',
        },
        {
          key: 'honorarios',
          label: 'Sueldo',
          class: 'text-right',
        },
        {
          key: 'adicional',
          class: 'text-right',
        },
        {
          key: 'otrosConceptos',
          class: 'text-right',
        },
        {
          key: 'liquidacionFinal',
          class: 'text-right',
        },
        {
          key: 'adelantos',
          class: 'text-right',
        },
        {
          key: 'total',
          class: 'text-right',
        },
      ],

      pagosFields: [
        {
          key: 'fechaRegistro',
        },
        {
          key: 'total',
          class: 'text-right',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      totalPagosFields: [
        {
          key: 'totales',
        },
        {
          key: 'total',
          class: 'text-right',
        },
        {
          key: 'col03',
        },
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  computed: {
    ...mapFields([
      'liquidacionSueldosDatos',
      'liquidacionSueldosPersonalDatos',
      'liquidacionSueldosPagosDatos'
    ]),
    totalPersonal() {
      let totalHonorarios = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.honorarios);
        }, 0);
      let totalAdicional = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.adicional);
        }, 0);
      let totalOtrosConceptos = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.otrosConceptos);
        }, 0);
      let totalLiquidacionFinal = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.liquidacionFinal);
        }, 0);
      let totalAdelantos = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.adelantos);
        }, 0);
      let totalGeneral = this.liquidacionSueldosPersonalDatos
        .reduce((total, personal) => {
            return total + parseFloat(personal.total);
        }, 0);

      let totales = [];
      totales.push({
        numero: '',
        totales: 'TOTAL',
        honorarios: totalHonorarios,
        adicional: totalAdicional,
        otrosConceptos: totalOtrosConceptos,
        liquidacionFinal: totalLiquidacionFinal,
        adelantos: totalAdelantos,
        total: totalGeneral
      })
      return totales;
    },
    totalPagos() {
      let total = this.liquidacionSueldosPagosDatos
        .reduce((total, pago) => {
            return total + parseFloat(pago.total);
        }, 0);


      let totales = [];
      totales.push({
        totales: 'TOTAL',
        total,
      })
      return totales;
    },
  },
  created() {
    this.liquidacionSueldosId = this.$route.params.id;
    
    this.getDatos();
  },  
  methods: {
    getDatos() {
      this.showSpinner();
      this.$store.dispatch('liquidacionSueldos/getDatos', this.liquidacionSueldosId)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    borrarPago (item) {
      this.showModalConfirm('¿Desea anular el pago seleccionado?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar(liquidacionSueldosPagoId) {
      this.showSpinner();

      let params = {
        liquidacionSueldosId: this.liquidacionSueldosId,
        liquidacionSueldosPagoId
      }

      this.$store.dispatch('liquidacionSueldosPagos/delete', params)
        .then(() => this.showModalMsj('El pago de la liquidación se anuló con éxito', this.getDatos, this.getDatos, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    goBack() {
      this.$router.go(-1);
    },
    registrarPago () {
      this.$router.push({ name: 'LiquidacionSueldosPago', 
                          params: { liquidacionSueldosId: this.liquidacionSueldosId }});
    },
    consultarPago(item) {
      this.$router.push({ name: 'LiquidacionSueldosPagoDatos', 
                          params: { liquidacionSueldosId: this.liquidacionSueldosId,
                                    id: item.id 
                                  }
                        });
    }
  }
}
</script>

<style>
  .liquidacion-sueldos-datos .datos-objeto thead th,
  .liquidacion-sueldos-datos .registro-ordenes thead th,
  .liquidacion-sueldos-datos .registro.pagos thead th {
    border-top: none;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td {
    vertical-align: middle;
    /* border: none; */
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="1"] {
    width: 5%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="2"] {
    width: 35%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="3"] {
    width: 10%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="4"] {
    width: 10%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="5"] {
    width: 10%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="6"] {
    width: 10%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="7"] {
    width: 10%;
  }
  .liquidacion-sueldos-datos .registro-ordenes table td[aria-colindex="8"] {
    width: 10%;
  }

  .liquidacion-sueldos-datos .registro.pagos table td[aria-colindex="1"] {
    width: calc(70% - 60px);
  }
  .liquidacion-sueldos-datos .registro.pagos table td[aria-colindex="2"] {
    width: 30%;
  }
  .liquidacion-sueldos-datos .registro.pagos table td[aria-colindex="3"] {
    width: 60px;
  }

  .liquidacion-sueldos-datos .registro-ordenes.totales table thead,
  .liquidacion-sueldos-datos .registro.totales table thead {
    display: none;
  }
  .liquidacion-sueldos-datos .registro-ordenes.totales table tr td,
  .liquidacion-sueldos-datos .registro.totales table tr td {
    border-top: none;
    font-weight: bold;
  }

</style>
